import React from "react";

export interface InputBlockLabelLabel {
  name?: string;
}

const InputBlockLabel: React.FC<React.PropsWithChildren<InputBlockLabelLabel>> =
  ({ children, name }) => {
    return (
      <label
        className="block font-medium text-sm mb-2 text-gray-700 "
        id={[name, "label"].join("-")}
        htmlFor={[name, "input"].join("-")}
      >
        {children}
        <style jsx>{`
          label > :global(*:first-child) {
            margin-top: 0;
          }

          label > :global(*:last-child) {
            margin-bottom: 0;
          }
        `}</style>
      </label>
    );
  };

const MemoInputBlockLabel = React.memo(InputBlockLabel);

export default MemoInputBlockLabel;
